// Identify the source of an action, whether it is from a mobile, a device, a third-party application (API) or LX
// CONNECT. If the origin of a log is malformed or is not defined, the origin must be set to `LX_CONNECT`.
// Note: The values are voluntary set in lower case by the backend.
export enum Origin {
  MOBILE_APPLICATION = "mobileapplication",
  DEVICE = "device",
  THIRD_PARTY_APPLICATION = "thirdpartyapplication",
  LX_CONNECT = "lxconnect",
}
